import React, { useMemo } from 'react';
import './PublicPageBackground.css';

interface PublicPageBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const PublicPageBackground: React.FC<PublicPageBackgroundProps> = ({ children, className }) => {
  // Generate individual stars with random positions and animations (memoized)
  const stars = useMemo(() => Array.from({ length: 75 }, (_, i) => ({
    id: i,
    size: Math.random() * 1 + 1, // 1-3px
    opacity: Math.random() * 1 + 0.2, // 0.2-1.0
    left: Math.random() * 80 + 10, // 20-80% (centered 60% width range)
    top: Math.random() * 70, // 0-70% (avoid planet area)
    animationDelay: Math.random() * 2, // 0-2s
    animationDuration: Math.random() * 10 + 10, // 10-20s
  })), []);

  return (
    <div className="public-page-background">
      {/* Stars Container */}
      <div className="public-stars-container">
        {stars.map((star) => (
          <div
            key={star.id}
            className="public-star"
            style={{
              left: `${star.left}%`,
              top: `${star.top}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              opacity: star.opacity,
              animationDelay: `${star.animationDelay}s`,
              animationDuration: `${star.animationDuration}s`,
            }}
          />
        ))}
      </div>
      
      {children}
    </div>
  );
};

export default PublicPageBackground;
